export const environment = {
  production: false,
  apiUrl: "https://api-dev.alaga.ph/",
  // apiUrl: "http://127.0.0.1:8000/",
  watermark: 'NOT FOR PRODUCTION',
  watermarkMode: 'repeat', // 'repeat' or 'center'
  watermarkOpacity: 0.05,
  watermarkSize: '2.5rem',
  watermarkGap: 80,
  PWD_ID_FRONT : 25,
  PWD_ID_BACK : 28,
  SP_ID: 29,
  // GETPASS "Transport QR" card on the dashboard. Off where GETPASS is not part of the deployment.
  transportQrEnabled: true,
};
